import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useGame } from '../context/GameContext.jsx';

const AlertModal = forwardRef(({ title, message, isConfirmation, onConfirm, onClose, confirmButtonText, cancelButtonText }, ref) => {
  const { translations, lang } = useGame();
  const modalElement = useRef(null);
  const bsModalInstance = useRef(null);

  useEffect(() => {
    if (modalElement.current && window.bootstrap) {
      bsModalInstance.current = new window.bootstrap.Modal(modalElement.current, {
        backdrop: 'static',
        keyboard: false
      });

      return () => {
        if (bsModalInstance.current) {
          bsModalInstance.current.dispose();
          bsModalInstance.current = null;
        }
      };
    }
  }, []);

  useImperativeHandle(ref, () => ({
    show: () => {
      bsModalInstance.current?.show();
    },
    hide: () => {
      bsModalInstance.current?.hide();
    }
  }), []);

  const handleConfirm = () => {
    bsModalInstance.current?.hide();
    onConfirm?.();
  };

  const handleClose = () => {
    bsModalInstance.current?.hide();
    onClose?.();
  };

  return (
    <div className="modal fade" ref={modalElement} tabIndex="-1" aria-labelledby="alertModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-dark text-light">
          <div className="modal-header bg-dark text-light border-bottom border-secondary">
            <h5 className="modal-title" id="alertModalLabel">{title}</h5>
            {!isConfirmation && (
                <button type="button" className="btn-close btn-close-white" onClick={handleClose} aria-label="Close"></button>
            )}
          </div>
          <div className="modal-body text-light" dangerouslySetInnerHTML={{ __html: message }}>
          </div>
          <div className="modal-footer bg-dark text-light border-top border-secondary">
            {isConfirmation ? (
              <>
                <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                  {confirmButtonText || translations[lang]?.confirm_new_game_yes || 'Sim'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                  {cancelButtonText || translations[lang]?.confirm_new_game_no || 'Não'}
                </button>
              </>
            ) : (
              <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                {confirmButtonText || 'OK'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default AlertModal;
